document.addEventListener("DOMContentLoaded", function () {

    const counters = document.querySelectorAll(".counter");

    const observer = new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if(entry.isIntersecting){

                const counter = entry.target;
                const target = Number(counter.dataset.count);

                const duration = 2000; // Animation time in milliseconds
                const startTime = performance.now();

                function animate(currentTime){

                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    counter.textContent = Math.floor(progress * target);

                    if(progress < 1){
                        requestAnimationFrame(animate);
                    }else{
                        counter.textContent = target;
                    }
                }

                requestAnimationFrame(animate);
                observer.unobserve(counter);

            }

        });

    }, { threshold: 0.4 });

    counters.forEach(counter => observer.observe(counter));

});